import { useState, PropsWithChildren, ReactNode, useEffect } from "react";
import Dropdown from "@/Components/Dropdown";
import NavLink from "@/Components/NavLink";
import ResponsiveNavLink from "@/Components/ResponsiveNavLink";
import { Link, router, usePage } from "@inertiajs/react";
import { User } from "@/types";
import { useTranslation } from "react-i18next";
import { ArrowUp2, Edit } from "iconsax-react";
import TopBar from "./TopBar";
import { useTheme } from "./ThemeContext";
import Footer from "./Footer";

import { SocialIcon } from "react-social-icons";
import { Button, ConfigProvider, FloatButton } from "antd";

import logo from "../../../public/logo.png";
import logoeng from "../../../public/logo_english.png";
import logodarkmode from "../../../public/logo_darkmode.png";
import logoendarkmode from "@/../../public/logo_en_darkmode.png";
import { WhatsAppOutlined } from "@ant-design/icons";

import MessageParser from "@/Components/Chatbot/MessageParser";
import ActionProvider from "@/Components/Chatbot/ActionProvider";
import Chatbot from "react-chatbot-kit";
import "react-chatbot-kit/build/main.css";
import useBotConfig from "@/Components/Chatbot/config";

import avatardoctor from "@/../../public/banner/doc_1.svg";
import ClockTheme from "@/Components/ClockTheme/ClockTheme";
import { AnimatePresence, motion } from "framer-motion";
import ApplicationLogo from "@/Components/ApplicationLogo";

export default function AuthWelcome({
    header,
    children,
}: PropsWithChildren<{ header?: ReactNode }>) {
    const [showingNavigationDropdown, setShowingNavigationDropdown] =
        useState(false);
    const { t, i18n } = useTranslation();
    const { currentRoute }: string | any = usePage().props;

    const [hoverIcons, setHoverIcons] = useState<Record<number, boolean>>({});
    const handleMouseEnter = (id: number) => {
        setHoverIcons((prev) => ({ ...prev, [id]: true }));
    };

    const handleMouseLeave = (id: number) => {
        setHoverIcons((prev) => ({ ...prev, [id]: false }));
    };
    const { emergency }: string | any = usePage().props;
    const { applang }: string | any = usePage().props;
    const { theme, toggleTheme } = useTheme();
    const { laravelsocial }: [] | any = usePage().props;
    const [isChatOpen, setIsChatOpen] = useState(false);

    const config: any = useBotConfig(theme, isChatOpen, setIsChatOpen);
    const [isFixed, setIsFixed] = useState(false);

    const width = window.innerWidth;
    useEffect(() => {
        if (applang) {
            i18n.changeLanguage(applang);
        }

        const handleScroll = () => {
            if (window.scrollY > 0) {
                setIsFixed(true);
            } else {
                setIsFixed(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [applang, i18n]);

    return (
        <div
            className="min-h-screen  dark:bg-gray-900 dark:text-white "
            dir={i18n.language === "ar" ? "rtl" : "ltr"}
        >
            <TopBar />
            <nav
                className={`bg-white border-b border-gray-100 dark:bg-gray-800 dark:!text-white dark:border-b-gray-600  ${
                    isFixed
                        ? "fixed lg:top-10 left-0 w-full top-12 z-[10000]"
                        : ""
                }`}
            >
                <div
                // className=" max:w-full  sm:px-6 sm:mx-0  "
                >
                    <div className="flex justify-between h-16">
                        <div className="flex gap-2">
                            <div
                                className={`shrink-0 flex items-center ${
                                    width < 600
                                        ? ""
                                        : i18n.language === "ar"
                                          ? ""
                                          : "mr-8"
                                }`}
                            >
                                <Link href="/">
                                    <ApplicationLogo className="block h-14 lg:h-14  w-auto fill-current " />
                                </Link>
                            </div>

                            <div className="hidden space-x-8 sm:-my-px  sm:flex md:hidden lg:flex lg:text-sm text-sm hover:text-custom-dark-blue">
                                <NavLink
                                    href={route("client.department.index", {
                                        locale: i18n.language,
                                    })}
                                    active={true}
                                >
                                    {t("topbar.department")}
                                </NavLink>
                            </div>
                            <div className="hidden space-x-8 sm:-my-px sm:ms-0 sm:flex md:hidden lg:flex lg:text-sm text-sm hover:text-custom-dark-blue ">
                                <NavLink
                                    href={route("client.disease.index", {
                                        locale: i18n.language,
                                    })}
                                    active={true}
                                >
                                    {t("sidebar.disease")}
                                </NavLink>
                            </div>

                            <div className="hidden space-x-8 sm:-my-px sm:ms-0 sm:flex md:hidden lg:flex lg:text-sm text-sm hover:text-custom-dark-blue">
                                <NavLink
                                    href={route("client.specialdoctor.index", {
                                        locale: i18n.language,
                                    })}
                                    active={true}
                                >
                                    {t("topbar.ourdoctors")}
                                </NavLink>
                            </div>

                            <div className="hidden space-x-8 sm:-my-px sm:ms-0 sm:flex md:hidden lg:flex lg:text-sm text-sm hover:text-custom-dark-blue">
                                <NavLink
                                    href={route(
                                                "client.magazine.index",
                                                { locale: i18n.language },
                                            )}
                                    active={true}
                                >
                                    {t("topbar.mediacenter")}
                                </NavLink>
                            </div>


                            <div className="hidden space-x-8 sm:-my-px sm:ms-0 sm:flex md:hidden lg:flex lg:text-sm text-sm hover:text-custom-dark-blue">
                                <NavLink
                                    href={route("client.offers.index", {
                                        locale: i18n.language,
                                    })}
                                    active={true}
                                >
                                    {t("topbar.offers")}
                                </NavLink>
                            </div>

                            <div className="hidden space-x-8 sm:-my-px sm:ms-0 sm:flex items-center md:hidden lg:flex pt-1">
                                <Dropdown>
                                    <Dropdown.Trigger>
                                        <span className="inline-flex rounded-md">
                                            <button
                                                type="button"
                                                className="inline-flex items-center  py-2  font-medium leading-4 lg:text-sm text-sm transition duration-150 ease-in-out border border-transparent rounded-md bg-inhert hover:text-custom-dark-blue focus:outline-none"
                                            >
                                                <span className="mx-2 dark:text-white">
                                                    {t("topbar.aboutus")}
                                                </span>
                                            </button>
                                        </span>
                                    </Dropdown.Trigger>

                                    <Dropdown.Content>
                                        <Dropdown.Link
                                            href={route(
                                                "client.aboutus.index",
                                                { locale: i18n.language },
                                            )}
                                        >
                                            {t("topbar.aboutus")}
                                        </Dropdown.Link>

                                        <Dropdown.Link
                                            href={route(
                                                "client.ouristory.index",
                                                { locale: i18n.language },
                                            )}
                                        >
                                            {t("topbar.ourhistory")}
                                        </Dropdown.Link>
                                        <Dropdown.Link
                                            href={route(
                                                "client.achievements.index",
                                                { locale: i18n.language },
                                            )}
                                        >
                                            {t("topbar.achievemnets")}
                                        </Dropdown.Link>

                                        <Dropdown.Link
                                            href={route("client.news.index", {
                                                locale: i18n.language,
                                            })}
                                        >
                                            {t("topbar.mecialnews")}
                                        </Dropdown.Link>
                                    </Dropdown.Content>
                                </Dropdown>
                            </div>

                            <div className="hidden space-x-8 sm:-my-px sm:ms-0 sm:flex md:hidden lg:flex lg:text-sm text-sm hover:text-custom-dark-blue">
                                <NavLink
                                    href={route("client.contactus.index", {
                                        locale: i18n.language,
                                    })}
                                    active={true}
                                >
                                    {t("topbar.contactus")}
                                </NavLink>
                            </div>
                        </div>
                        <div
                            className={`hidden sm:flex sm:items-center sm:ms-6 me-7 md:hidden lg:flex ${
                                i18n.language === "ar" ? "" : "!ml-[60px]"
                            } `}
                        >
                            <div className="flex items-center mt-1">
                                <button onClick={toggleTheme}>
                                    <ClockTheme />
                                </button>
                            </div>

                            <div className=" space-x-8 sm:-my-px sm:ms-5">
                                <Button
                                    className={`rounded-full text-sm lg:text-sm w-full transition-all duration-700 group relative hover:w-[115%]  !border-custom-dark-blue dark:!border-white   p-4 ${
                                        i18n.language === "ar"
                                            ? "hover:ml-0"
                                            : "hover:mr-0"
                                    }  flex justify-between items-center hover:!bg-custom-dark-blue hover:!text-white font-sans !text-custom-dark-blue dark:!text-white`}
                                >
                                    <Link
                                        href={route(
                                            "client.appointment.index",
                                            { locale: i18n.language },
                                        )}
                                        className={`font-sans ${
                                            i18n.language === "ar"
                                                ? "group-hover:ml-2"
                                                : "group-hover:mr-2"
                                        } `}
                                    >
                                        {t("topbar.appintment")}
                                    </Link>
                                    <Edit
                                        className={`absolute opacity-0 ${
                                            i18n.language === "ar"
                                                ? "left-1/2 group-hover:left-[10%]"
                                                : "right-1/2 group-hover:right-[10%]"
                                        }  transition-all duration-500 ease-in-out  group-hover:opacity-100 group-hover:!text-white`}
                                        size="18"
                                    />
                                </Button>
                            </div>
                        </div>

                        <div className="-me-2 flex items-center sm:hidden md:flex lg:hidden">
                            <div>
                                <button onClick={toggleTheme}>
                                    <ClockTheme />
                                </button>
                            </div>

                            <button
                                onClick={() =>
                                    setShowingNavigationDropdown(
                                        (previousState) => !previousState,
                                    )
                                }
                                className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500 transition duration-150 ease-in-out"
                            >
                                <svg
                                    className="h-6 w-6"
                                    stroke="currentColor"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        className={
                                            !showingNavigationDropdown
                                                ? "inline-flex"
                                                : "hidden"
                                        }
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M4 6h16M4 12h16M4 18h16"
                                    />
                                    <path
                                        className={
                                            showingNavigationDropdown
                                                ? "inline-flex"
                                                : "hidden"
                                        }
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M6 18L18 6M6 6l12 12"
                                    />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>

                <div
                    className={
                        (showingNavigationDropdown ? "block " : "hidden") + ""
                    }
                >
                    <div className="pt-2 pb-3 space-y-1">
                        <ResponsiveNavLink
                            href={route("/home")}
                            active={route().current("/home")}
                        >
                            {t("topbar.home")}
                        </ResponsiveNavLink>
                    </div>

                    <div className="pt-2 pb-3 space-y-1">
                        <ResponsiveNavLink
                            href={route("client.department.index", {
                                locale: i18n.language,
                            })}
                            active={false}
                        >
                            {t("topbar.department")}
                        </ResponsiveNavLink>
                    </div>

                    <div className="pt-2 pb-3 space-y-1">
                        <ResponsiveNavLink
                            href={route("client.specialdoctor.doctors", {
                                locale: i18n.language,
                            })}
                            active={false}
                        >
                            {t("topbar.ourdoctors")}
                        </ResponsiveNavLink>
                    </div>

                    <div className="pt-2 pb-3 space-y-1">
                        <Dropdown>
                            <Dropdown.Trigger>
                                <span className="inline-flex rounded-md">
                                    <button
                                        type="button"
                                        className="inline-flex items-center px-3 py-2 text-sm font-medium leading-4 text-gray-500 transition duration-150 ease-in-out border border-transparent rounded-md bg-inhert hover:text-gray-700 focus:outline-none"
                                    >
                                        <span className="mx-2">
                                            {t("topbar.aboutus")}
                                        </span>
                                    </button>
                                </span>
                            </Dropdown.Trigger>

                            <Dropdown.Content maincontentClass="!right-20 top-0">
                                <Dropdown.Link
                                    href={route("client.aboutus.index", {
                                        locale: i18n.language,
                                    })}
                                >
                                    {t("topbar.aboutus")}
                                </Dropdown.Link>

                                <Dropdown.Link
                                    href={route("client.ouristory.index", {
                                        locale: i18n.language,
                                    })}
                                >
                                    {t("topbar.ourhistory")}
                                </Dropdown.Link>
                            </Dropdown.Content>
                        </Dropdown>
                    </div>

                    <div className="pt-2 pb-3 space-y-1">
                        <Dropdown>
                            <Dropdown.Trigger>
                                <span className="inline-flex rounded-md">
                                    <button
                                        type="button"
                                        className="inline-flex items-center px-3 py-2 text-sm font-medium leading-4 text-gray-500 transition duration-150 ease-in-out border border-transparent rounded-md bg-inhert hover:text-gray-700 focus:outline-none"
                                    >
                                        <span className="mx-2">
                                            {t("topbar.mediacenter")}
                                        </span>
                                    </button>
                                </span>
                            </Dropdown.Trigger>

                            <Dropdown.Content>
                                <Dropdown.Link
                                    href={route("client.news.index", {
                                        locale: i18n.language,
                                    })}
                                >
                                    {t("topbar.mecialnews")}
                                </Dropdown.Link>
                                <Dropdown.Link
                                    href={route("client.magazine.index", {
                                        locale: i18n.language,
                                    })}
                                >
                                    {t("topbar.magazine")}
                                </Dropdown.Link>
                                <Dropdown.Link
                                    href={route("client.achievements.index", {
                                        locale: i18n.language,
                                    })}
                                >
                                    {t("topbar.achievemnets")}
                                </Dropdown.Link>
                            </Dropdown.Content>
                        </Dropdown>
                    </div>

                    <div className="pt-2 pb-3 space-y-1">
                        <ResponsiveNavLink
                            href={route("client.offers.index", {
                                locale: i18n.language,
                            })}
                            active={false}
                        >
                            {t("topbar.offers")}
                        </ResponsiveNavLink>
                    </div>

                    <div className="pt-2 pb-3 space-y-1">
                        <ResponsiveNavLink
                            href={route("client.contactus.index", {
                                locale: i18n.language,
                            })}
                            active={false}
                        >
                            {t("topbar.contactus")}
                        </ResponsiveNavLink>
                    </div>

                    <div className="pt-2 pb-3 space-y-1">
                        <ResponsiveNavLink
                            href={route("client.appointment.index", {
                                locale: i18n.language,
                            })}
                            active={false}
                        >
                            {t("topbar.appintment")}
                        </ResponsiveNavLink>
                    </div>
                </div>
            </nav>

            {header && (
                <header className="bg-white shadow">
                    <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
                        {header}
                    </div>
                </header>
            )}
            <div
                className={`flex flex-col justify-evenly fixed bg-custom-dark-blue  z-50 ${
                    i18n.language === "ar"
                        ? "left-0 rounded-s-xl"
                        : "left-0 rounded-e-xl"
                } top-40  xs:top-48`}
            >
                {laravelsocial.length > 0 ? (
                    <div className="flex flex-col items-center gap-4 py-2 ">
                        {laravelsocial?.map((socail: any) => (
                            <SocialIcon
                                key={socail.id}
                                className='mx-2 !size-6 cursor-pointer relative after:absolute after:content-[""] after:hover:bg-custom-dark-blue  after:duration-300 after:top-0 after:right-0 after:hover:-right-2 !overflow-visible after:h-full after:w-full after:-z-50 after:rounded-s-full after:delay-75 transform transition hover:translate-x-2 duration-300'
                                bgColor="transparent"
                                fgColor={
                                    hoverIcons[socail.id] ? "yellow" : "white"
                                }
                                network={socail.name === "tr" ? "linktree" : ""}
                                url={socail.social_link}
                                target="_blank"
                                style={{ height: 15, width: 15 }}
                                onMouseEnter={() => handleMouseEnter(socail.id)}
                                onMouseLeave={() => handleMouseLeave(socail.id)}
                            />
                        ))}
                    </div>
                ) : (
                    <div className="flex flex-col items-center gap-4 py-2">
                        <SocialIcon
                            className='mx-2 !size-6 cursor-pointer relative after:absolute after:content-[""] after:hover:bg-yellow-400 after:duration-300 after:top-0 after:right-0 after:hover:-right-2 !overflow-visible after:h-full after:w-full after:-z-50 after:rounded-s-full after:delay-75 transform transition hover:translate-x-2 duration-300'
                            bgColor="transparent"
                            fgColor="black"
                            network="facebook"
                            target="_blank"
                            style={{ height: 15, width: 15 }}
                        />
                        <SocialIcon
                            className='mx-2 !size-6 cursor-pointer relative after:absolute after:content-[""] after:hover:bg-yellow-400 after:duration-300 after:top-0 after:right-0 after:hover:-right-2 !overflow-visible after:h-full after:w-full after:-z-50 after:rounded-s-full after:delay-75 transform transition hover:translate-x-2 duration-300'
                            bgColor="transparent"
                            fgColor="black"
                            network="x"
                            target="_blank"
                            style={{ height: 15, width: 15 }}
                        />
                        <SocialIcon
                            className='mx-2 !size-6 cursor-pointer relative after:absolute after:content-[""] after:hover:bg-yellow-400 after:duration-300 after:top-0 after:right-0 after:hover:-right-2 !overflow-visible after:h-full after:w-full after:-z-50 after:rounded-s-full after:delay-75 transform transition hover:translate-x-2 duration-300'
                            bgColor="transparent"
                            fgColor="black"
                            network="instagram"
                            target="_blank"
                            style={{ height: 15, width: 15 }}
                        />
                        <SocialIcon
                            className='mx-2 !size-6 cursor-pointer relative after:absolute after:content-[""] after:hover:bg-yellow-400 after:duration-300 after:top-0 after:right-0 after:hover:-right-2 !overflow-visible after:h-full after:w-full after:-z-50 after:rounded-s-full after:delay-75 transform transition hover:translate-x-2 duration-300'
                            bgColor="transparent"
                            fgColor="black"
                            network="linkedin"
                            target="_blank"
                            style={{ height: 15, width: 15 }}
                        />
                        <SocialIcon
                            className='mx-2 !size-6 cursor-pointer relative after:absolute after:content-[""] after:hover:bg-yellow-400 after:duration-300 after:top-0 after:right-0 after:hover:-right-2 !overflow-visible after:h-full after:w-full after:-z-50 after:rounded-s-full after:delay-75 transform transition hover:translate-x-2 duration-300'
                            bgColor="transparent"
                            fgColor="black"
                            network="youtube"
                            target="_blank"
                            style={{ height: 15, width: 15 }}
                        />
                    </div>
                )}
            </div>
            <main>{children}</main>

            <div
                className={`fixed size-16 rounded-full bg-custom-dark-blue hover:bg-custom-sky-blue m-6 bottom-0 ${
                    i18n.language === "ar" ? "left-0" : "right-0"
                }  flex justify-center items-center  cursor-pointer dark:bg-custom-cyan dark:hover:bg-custom-dark-blue z-50 `}
            >
                <a
                    href={`https://wa.me/+966${emergency?.number}`}
                    target="_blank"
                >
                    <WhatsAppOutlined className="group-hover:text-white !text-white text-3xl" />
                </a>
            </div>
            {/* <ConfigProvider
                theme={{
                    token: {
                        colorBgElevated: '#0033A0',
                        controlHeightLG: 60,
                        fontSizeIcon: 25
                    },
                }}
            >
                <FloatButton
                    className='hover:bg-custom-sky-blue group '
                    icon={
                        <a
                            href={`https://wa.me/+966${emergency.number}`}
                            target="_blank"
                        >
                            <WhatsAppOutlined className='group-hover:text-white !text-white' />
                        </a>
                    }
                />
            </ConfigProvider>

             */}

            <div dir={i18n.language === "ar" ? "ltr" : "rtl"}>
                <ConfigProvider
                    theme={{
                        token: {
                            // colorBgElevated: '#0033A0',
                            controlHeightLG: 60,
                            fontSizeIcon: 25,
                        },
                    }}
                >
                    <FloatButton.BackTop
                        className={`group mb-16 ${
                            i18n.language === "ar" ? "mr-[10px]" : "ml-[12px]"
                        } hover:bg-custom-dark-blue dark:hover:bg-custom-cyan z-40`}
                        icon={
                            <ArrowUp2 className="group-hover:text-white text-sm lg:text-sm mx-auto animate-ping hover:animate-none hover:!opacity-100 " />
                        }
                    />
                </ConfigProvider>

                {/* <ChatComponent /> */}

                <div
                    className={`fixed size-20 rounded-full bg-custom-dark-blue hover:bg-custom-cyan m-6 bottom-0 ${
                        i18n.language === "ar" ? "right-0" : "left-0"
                    }  flex justify-center items-end  cursor-pointer dark:bg-custom-cyan dark:hover:bg-custom-dark-blue z-50`}
                >
                    <div
                        className="relative w-full h-full overflow-hidden rounded-full"
                        onClick={() => setIsChatOpen(!isChatOpen)}
                    >
                        <img
                            src={avatardoctor}
                            className="-bottom-2 absolute"
                        />
                    </div>

                    <AnimatePresence>
                        {isChatOpen && (
                            <motion.div
                                className={`relative ${
                                    i18n.language === "ar"
                                        ? "right-20"
                                        : "left-24"
                                }`}
                                initial={{ opacity: 0, scaleY: 0 }}
                                animate={{ opacity: 1, scaleY: 1 }}
                                exit={{ opacity: 0, scaleY: 0 }}
                                transition={{
                                    duration: 0.5,
                                    ease: "easeInOut",
                                }}
                                style={{ transformOrigin: "bottom" }}
                            >
                                <Chatbot
                                    placeholderText={t(
                                        "chatbot.inputPlaceholder",
                                    )}
                                    headerText={t("chatbot.botname")}
                                    config={config}
                                    messageParser={MessageParser}
                                    actionProvider={ActionProvider}
                                />
                            </motion.div>
                        )}
                    </AnimatePresence>
                </div>
            </div>
            <Footer />
        </div>
    );
}
